// In-memory lock for supabase-js on native WebViews, where navigator.locks
// contention can stall session restoration and OAuth token persistence.
const queues = new Map<string, Promise<unknown>>();

export const memoryLock = async <R>(name: string, _acquireTimeout: number, fn: () => Promise<R>): Promise<R> => {
  const previous = queues.get(name) ?? Promise.resolve();
  const run = previous.catch(() => undefined).then(() => fn());
  const tail = run.catch(() => undefined);
  queues.set(name, tail);
  try {
    return await run;
  } finally {
    if (queues.get(name) === tail) queues.delete(name);
  }
};
